import { call, put, takeEvery } from 'redux-saga/effects';
import { NewDealerActionKeys, ValidateNewDealerRequest } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../newDealerApi';

function* validateNewDealerRequestSaga(action: ValidateNewDealerRequest) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<string[]> = yield call(
    api.validateNewDealerRequest,
    action.payload.newDealerRequestId
  );

  if (!response.requestFailed && response.value) {
    let title: string = 'Validation Successful';
    if (response.value.length > 0) {
      // show dialog with all errors
      title = 'The request has failed the following validation steps:';
    }

    yield put(
      uiActionCreators.showMessageDialog({
        messages: response.value,
        title
      })
    );
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchValidateNewDealerRequest() {
  yield takeEvery(NewDealerActionKeys.VALIDATE_NEW_DEALER_REQUEST, validateNewDealerRequestSaga);
}
